import { useDispatch } from "react-redux";
import { MONTHS } from "../../../../utils/Constants";
import { setActivity } from "../../../../redux/slices/userActivitySlice";

const ChatUser = ({ activity, active }) => {
   const dispatch = useDispatch();

    const openChatWindow=(activity)=>{
        dispatch(setActivity(activity));
    }

  return (
    <a href="#" className={`media ${active ? "selected" : "new"}`}>
      {/* <div className="main-img-user online">
        <img src={`../assets/img/users/${img}`} alt={name} />
        {unread && <span>{unread}</span>}
      </div> */}
      <div className="media-body" onClick={()=>openChatWindow(activity)}>
        <div className="media-contact-name">
          <span>{MONTHS[activity.month-1]}</span>
          <span>{activity.year}</span>
        </div>
        <p>Questions: {activity.questions_count}</p>
      </div>
    </a>
  );
};

export default ChatUser
